export const FETCH_RATEPLAN_BEGIN = 'FETCH_RATEPLAN_BEGIN'
export const FETCH_RATEPLAN_SUCCESS = 'FETCH_RATEPLAN_SUCCESS'
export const FETCH_RATEPLAN_ERROR = 'FETCH_RATEPLAN_ERROR'